import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import { queryClient } from "App";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import useMetaSyncInProgress, {
  META_SYNC_POLL_INTERVAL_MS,
} from "hooks/useMetaSyncInProgress";
import MetaAdService from "services/MetaAd";

const adsQueryKey = accountId => ["meta-ads", accountId];

const AD_COLUMNS = [
  {
    header: "ID",
    id: "ID",
    accessorKey: "id",
    size: 50,
    cell: ({ row }) => (
      <p style={{ fontWeight: "bold" }}>{row.getValue("ID")}</p>
    ),
  },
  { id: "Name", accessorKey: "name", header: "Name", size: 220 },
  {
    id: "Creative",
    accessorKey: "creative_name",
    header: "Creative",
    size: 180,
  },
  { id: "Status", accessorKey: "status", header: "Status", size: 120 },
  {
    id: "Delivery",
    accessorKey: "effective_status",
    header: "Delivery",
    size: 140,
  },
];

const MetaAdsTab = () => {
  const { accountId } = useParams();

  const columns = useMemo(() => AD_COLUMNS, []);
  const isSyncing = useMetaSyncInProgress(accountId, "live");

  const invalidateAds = useCallback(
    () => queryClient.invalidateQueries({ queryKey: adsQueryKey(accountId) }),
    [accountId]
  );

  const fetchAds = useCallback(
    async queryParams => {
      const next = getNextQueryParams(queryParams, columns);
      return MetaAdService.list(accountId, next);
    },
    [accountId, columns]
  );

  return (
    <div className="tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:min-w-0">
      <BaseTableV3
        columns={columns}
        header="Ads"
        tableName="meta_ads"
        queryKey={adsQueryKey(accountId)}
        fetchData={fetchAds}
        invalidateData={invalidateAds}
        refetchInterval={isSyncing ? META_SYNC_POLL_INTERVAL_MS : undefined}
        enableSearch
        enableSettings
      />
    </div>
  );
};

export default MetaAdsTab;
